import { API } from "../../../api";
import { nicepayClientId } from "./keys";

type NicePayRequestArgs = {
  orderId: string;
  amount: number;
  goodsName: string;
  method?: string;
  vbankHolder?: string;
  returnUrl?: string;
  errorCb?: (...args: any[]) => void;
};

export function requestPaymentNicePay({
  orderId,
  amount,
  goodsName,
  method = "card",
  vbankHolder = "나이스",
  returnUrl = "/package/order-nice/",
  errorCb = () => {},
}: NicePayRequestArgs): void {
  const AUTHNICE = (window as any).AUTHNICE;
  if (!AUTHNICE) {
    throw new Error("AUTHNICE is not defined");
  }
  if (!nicepayClientId) {
    throw new Error("nicepayClientId is not defined");
  }

  AUTHNICE.requestPay({
    clientId: nicepayClientId,
    method,
    orderId,
    amount,
    goodsName,
    vbankHolder,
    returnUrl: API.defaults.baseURL + returnUrl,
    fnError: errorCb,
  });
}
